import {Background, Flex} from "../../../styles/CommonStyles";
import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {useMainContext} from "../../../core/contexts/main";
import Text from "../../../core/utils/Text";
import {NoAccessDesc, NoAccessText} from "../../../styles/layout";


const NoAccess = () => {

    const navigate = useNavigate()
    const { theme } = useMainContext()

    useEffect(() => {
        const timeout = setTimeout(() => navigate('/profile'), 5000)
        return () => clearTimeout(timeout)
    }, [])

    return (
        <Flex fw height='100vh' style={{ overflow: 'hidden' }}>
            <Background bg='mainBg'>
                <img
                    src={require(`../../../assets/images/no-access-${theme}.png`)}
                    alt={' '}
                    style={{ objectFit: 'cover' }}

                />
                <NoAccessText>
                    <Text tid={'no-access'} />
                </NoAccessText>
                <NoAccessDesc>
                    <Text tid={'moving-to-profile'} />
                </NoAccessDesc>
            </Background>
        </Flex>
    )
}



export default NoAccess
